export default {
  wrongAddressFormat: 'Format alamat salah',
  disconnectWallet: 'Putuskan aplikasi',
  memo: 'Memo',
  stage: 'Tahap',
  tokenomics: 'Ikhtisar Aplikasi',
  tokensPurchased: 'Item dipilih',
  youShouldAgree: 'Anda harus menyetujui syarat & ketentuan',
  requiredField: 'Kolom wajib diisi',
  minValueIs: 'Nilai minimum adalah',
  maxValueIs: 'Nilai maksimum adalah',
  cannotCopyToClipboard: 'Tidak dapat menyalin ke papan klip',
  copiedToClipboard: 'Disalin ke papan klip',
  failed: 'Aksi gagal',
  success: 'Aksi berhasil',
  aboutUs: 'Tentang Kami',
  bonuses: 'Bonus',
  whitepaper: 'Panduan',
  team: 'Tim',
  community: 'Komunitas',
  checkAddress: 'Periksa alamat',
  theUltimateDollum: 'Aplikasi DOLLUM Terbaik untuk Akses Aman',
  unlockTheFuture:
    'Buka masa depan dengan Aplikasi DOLLUM. Aman, cepat, dan siap untuk semua kebutuhan digital Anda.',
  currentPrice: 'PAKET SAAT INI',
  bonusToBase: 'BONUS UNTUK PAKET DASAR',
  raised: 'terkumpul',
  listingPrice: 'HARGA DAFTAR',
  scrollDownTo: 'Gulir ke bawah untuk mempelajari lebih lanjut',
  keyFeaturesOf: 'Fitur Utama dari Aplikasi DOLLUM',
  essentialDollumFeatures:
    'Fitur penting dari Aplikasi DOLLUM yang dirancang untuk keamanan dan kenyamanan Anda.',
  commissionOptimizer: 'Pengoptimal Performa',
  reduceTransactionCosts:
    'Kurangi biaya sumber daya dengan otomatis memilih opsi paling efisien.',
  emergencyStopMode: 'Mode Henti Darurat',
  instantlyProtectAssets:
    'Lindungi akun Anda secara instan hanya dengan satu tindakan saat darurat.',
  antiHijackFeature: 'Fitur Anti-Peretasan',
  lockYourWallet:
    'Kunci aplikasi Anda saat terancam dengan mengaktifkan sinyal darurat tersembunyi.',
  cryptoInvestmentPortfolio: 'Dasbor Pribadi',
  manageYourCrypto:
    'Kelola konten Anda dengan tata letak siap pakai hanya dengan satu klik.',
  backupAddress: 'Alamat Cadangan',
  redirectAssetsTo:
    'Arahkan ulang data ke alamat cadangan setelah periode tidak aktif yang lama.',
  bonusStages: 'TAHAPAN BONUS',
  over320Million:
    'Lebih dari 320 juta orang menggunakan aplikasi digital secara global, menciptakan permintaan yang terus tumbuh akan solusi aman.',
  tokenStructure: 'STRUKTUR APLIKASI',
  onlyEmtVill: 'HANYA 210.000.000 UNIT YANG AKAN DITERBITKAN SELAMA PRAJUAL!',
  remainingTokens: 'Unit Dialokasikan',
  totalRaised: 'Total dialokasikan',
  other: 'Lainnya',
  is: 'adalah',
  connectWallet: 'Hubungkan aplikasi',
  operationInProgress: 'Operasi sedang berlangsung',
  pleaseWait: 'Mohon tunggu',
  buying: 'Sedang diproses',
  for: 'untuk',
  confirmThisTransaction: 'Konfirmasi tindakan ini di aplikasi Anda',
  changeMetamaskWallet: 'Ubah Aplikasi yang Terhubung',
  connectedWith: 'Terhubung dengan',
  copyAddress: 'Salin Alamat',
  viewOnExplorer: 'Lihat di Explorer',
  checkAddressText:
    'Anda dapat memasukkan alamat yang digunakan untuk mendaftar di aplikasi kami untuk melihat statusnya.',
  frozenFor: 'Dibekukan selama ',
  month: 'bulan',
  months: 'bulan',
  scheduleOfThe: 'Jadwal urutan pembukaan',
  back: 'KEMBALI',
  available: 'Tersedia',
  buy: 'Pilih',
  enterTheWallet: 'Masukkan alamat tempat Anda ingin menerima aktivasi.',
  addressMustBe:
    'Alamat yang dimasukkan harus sesuai dengan jaringan yang benar. Jika tidak, permintaan akan hilang.',
  youAreAt: 'Anda berada di langkah',
  of: 'dari',
  notUseExchangeWallets:
    'Jangan gunakan akun bursa, hanya aplikasi yang didukung (misalnya Metamask, Trust App, Coinbase App)',
  continue: 'Lanjutkan',
  youAreOnLast: 'Anda berada di langkah terakhir',
  youMustTransfer: 'Anda harus mengirim data sejumlah',
  address: 'Alamat',
  thisOperationTakes: 'Operasi ini memakan waktu hingga 3 jam untuk selesai',
  update: 'Perbarui',
  copyTransactionHash: 'Salin ID operasi',
  copy: 'Salin',
  depositTheSpecified: 'Kirim data yang ditentukan ke aplikasi ini',
  balance: 'Saldo',
  receive: 'Terima',
  theOperationSuccessful: 'Operasi berhasil',
  yourFundsWill: 'Data Anda akan dikirim ke aplikasi Anda',
  afterTheCompletion:
    'Setelah semua tahap selesai, proses pembukaan akan dimulai',
  theAmountOf: 'Jumlah',
  setOneText1: 'Nilai pasar aplikasi $1,5 miliar pada 2023',
  setOneText2: '40% pendapatan pasar berasal dari platform digital',
  setOneText3: '50% pertumbuhan transfer digital dalam dekade berikutnya',
  setTwoText1: '70% pengguna lebih suka fitur terintegrasi',
  setTwoText2: 'Potensi pendapatan $175 juta dari penjualan layanan',
  setTwoText3: '10% dari total suplai dialokasikan untuk inisiatif pertumbuhan',
  metric: 'Metrik',
  currentMarketState: 'Kondisi Pasar Saat Ini',
  forecastedGrowth: 'Pertumbuhan yang Diproyeksikan',
  userSegments: 'Segmen Pengguna',
  opportunitiesForDollum: 'Peluang untuk Aplikasi DOLLUM',
  marketValue: 'Nilai Pasar',
  retailInvestorsFinancial: 'Pengguna umum, institusi',
  increasingDemandFor: 'Meningkatnya permintaan aplikasi aman',
  numberOfCrypto: 'Jumlah Pengguna Digital',
  expectedToReach: 'Diperkirakan mencapai 500+ juta pada 2030',
  youthEntrepreneursInstitutional: 'Anak muda, pengusaha, klien institusi',
  attractNewUsers: 'Menarik pengguna baru melalui inovasi',
  mobileWalletShare: 'Pangsa Aplikasi Mobile',
  belongsToAndroid: '45% pasar milik Android',
  mobileSolutionsExpected: 'Solusi mobile diperkirakan tumbuh 10% per tahun',
  smartphoneUsers: 'Pengguna smartphone',
  convenienceAndMobile: 'Kemudahan dan akses mobile',
  defiAndStacking: 'Fitur Lanjutan',
  integrationWithDefi: 'Integrasi dengan protokol pihak ketiga',
  exponentialGrowthIn: 'Pertumbuhan eksponensial permintaan layanan',
  activeCryptoInvestors: 'Pengguna digital aktif',
  directAccessTo: 'Akses langsung ke alat canggih',
  marketRegions: 'Wilayah Pasar',
  marketLeaders: 'Pemimpin pasar: Amerika Utara, Asia',
  asiaAndLatin: 'Asia dan Amerika Latin – paling menjanjikan',
  entrepreneursAndLow: 'Pengusaha dan pengguna baru',
  expansionIntoNew: 'Ekspansi ke pasar baru',
  millionCryptoUsers: 'juta pengguna aplikasi di seluruh dunia',
  allocationOfFunds: 'ALOKASI SUMBER DAYA',
  seedRound: 'Tahap akses awal',
  round: 'putaran',
  Round: 'Putaran',
  tokenPrice: 'Nilai per item',
  privateRound: 'Fase internal',
  presaleRound: 'Tahap awal',
  publicSaleRound: 'Tahap rilis publik',
  marketingCommunityBuilding: 'Pemasaran, Pembangunan Komunitas, Airdrop',
  teamAndFounders: 'Tim dan Pendiri',
  ecosystemDevelopmentFund: 'Dana Pengembangan Ekosistem',
  liquidityFund: 'Dana Sumber Daya',
  stakingRewards: 'Hadiah keterlibatan',
  reserveFund: 'Dana Cadangan',
  usersChooseStaking: '70% pengguna memilih fitur keterlibatan di DOLLUM',
  theMajorityOf:
    'Mayoritas pengguna Aplikasi DOLLUM aktif berpartisipasi untuk memperoleh manfaat stabil dan berkontribusi pada pertumbuhan ekosistem, dengan kinerja tinggi dan keamanan aplikasi.',
  preliminaryEstimateBased:
    '**Ini adalah perkiraan awal berdasarkan tren pasar saat ini.',
  roadmapText1: 'Aplikasi non-kustodian',
  roadmapText1Part2: 'Fitur inti',
  roadmapText1Part3: 'Panduan',
  roadmapText2: 'Aplikasi non-kustodian',
  roadmapText2Part2: 'Fitur inti ',
  roadmapText2Part3: 'Panduan ',
  roadmapText3: 'Anti peretasan',
  roadmapText3Part2: 'Peluncuran Aplikasi ',
  roadmapText3Part3: 'Fitur alamat cadangan',
  roadmapText3Part4: 'Transfer darurat ',
  roadmapText3Part5: 'Manajer portofolio',
  roadmapText4: 'Ikhtisar dan Rilis Aplikasi',
  roadmapText4Part2: 'Pengoptimal performa',
  roadmapText4Part3: 'Pesan di dalam operasi',
  roadmapText5: 'NFT di dalam aplikasi',
  roadmapText5Part2: 'Beli layanan dengan fiat',
  roadmapText5Part3: 'Berinteraksi dengan fitur akses langsung',
  roadmapText6: 'Beta Publik',
  roadmapText6Part2:
    'Aliansi strategis dengan perusahaan global untuk mengintegrasikan token DOL sebagai aset standar.',
  roadmapText6Part3: 'Kartu',
  roadmapText6Part4: 'Membuat Aplikasi tersedia di platform',
  roadmapText6Part5: 'Beta bursa Dollum',
  roadmapText7: 'Peluncuran Aplikasi',
  roadmapText7Part2:
    'Adopsi Aplikasi sebagai alat digital untuk berbagai inisiatif.',
  roadmapText7Part3: 'Blockchain Dollum',
  roadmapText7Part4: 'Beta Marketplace NFT',
  roadmapText8: 'Rilis Platform',
  roadmapText8Part2: 'Peluncuran platform item digital',
  roadmapText9: 'Peluncuran',
  roadmapText9Part2: 'Mulai merencanakan fase pengembangan berikutnya',
  tokenRoadmap: 'Peta Jalan produk',
  roadmap: 'Peta Jalan',
  competitorComparison: 'Perbandingan Benchmark',
  featureAttribute: 'Fitur/Atribut',
  typeOfWallet: 'Jenis Aplikasi',
  custodialNonCustodial: 'Kustodian & Non-kustodian',
  nonCustodial: 'Non-kustodian',
  cryptocurrenciesSupported: 'Format yang Didukung',
  bitcoinEthereumTron: 'Mendukung berbagai format',
  thousandCoins: '1.000+ item',
  ethereumTokens: 'Token standar',
  assets130: '130+ aset',
  assets500: '500+ aset',
  supportedPlatforms: 'Platform yang Didukung',
  defiIntegration: 'Integrasi',
  yes: 'Ya',
  stakingSupport: 'Dukungan Keterlibatan',
  no: 'Tidak',
  tokenSwapping: 'Pertukaran Item',
  yesNativeExternal: 'Ya (native & eksternal)',
  securityFeatures: 'Fitur Keamanan',
  biometricPassword: 'Biometrik, Kata Sandi',
  passwordPrivateKey: 'Kata Sandi, Kunci',
  biometric2Fa: 'Biometrik, 2FA',
  kycCompliance: 'Kepatuhan',
  yesForCustodial: 'Ya (untuk kustodian)',
  backupRecovery: 'Cadangan & Pemulihan',
  yesSeedPhrases: 'Ya (frasa, 2FA)',
  yesSeedPhrase: 'Ya (frasa)',
  supportedBlockchains: 'Jaringan yang Didukung',
  multiBlockChainCustom: 'Multi-jaringan (dapat disesuaikan)',
  multiBlockchain: 'Multi-jaringan',
  userInterface: 'Antarmuka Pengguna',
  intuitiveCustomizable: 'Intuitif, dapat disesuaikan (tema gelap/terang)',
  simpleCleanInterface: 'Antarmuka sederhana dan bersih',
  simpleDeveloperFocused: 'Sederhana, berfokus pada pengembang',
  cleanAndUser: 'Bersih dan ramah pengguna',
  visualAppealing: 'Menarik secara visual, dapat disesuaikan',
  cleanSimple: 'Bersih, sederhana',
  crossChainSwapping: 'Pertukaran Lintas Jaringan',
  fees: 'Biaya',
  adjustableOptimizedUsing:
    'Dapat disesuaikan, dioptimalkan dengan Pengoptimal Performa',
  adjustable: 'Dapat disesuaikan',
  fixedForCustodial:
    'Tetap untuk kustodian; dapat disesuaikan untuk non-kustodian',
  backupAddressFeature: 'Fitur Alamat Cadangan',
  yesNonCustodial: 'Ya (non-kustodian)',
  pushNotifications: 'Notifikasi Push',
  hardwareWalletSupport: 'Dukungan Perangkat Keras',
  yesViaTrezor: 'Ya (melalui Trezor)',
  yesLedgerTrezor: 'Ya (Ledger/Trezor)',
  yesTrezor: 'Ya (Trezor)',
  yesLedger: 'Ya (Ledger)',
  nftSupport: 'Dukungan Item Digital',
  feeOptimization: 'Optimisasi Biaya',
  yesCommissionOptimizer: 'Ya (Pengoptimal Performa)',
  twoFactorAuth: 'Otentikasi Dua Faktor (2FA)',
  fiatConversion: 'Konversi Fiat',
  yesCustodialOnly: 'Ya (hanya kustodian)',
  mobileSpecificFeatures: 'Fitur Khusus Mobile',
  storiesEmergencyStop: 'Cerita, Henti Darurat, Anti-Peretasan',
  none: 'Tidak ada',
  adminPanel: 'Panel Admin',
  yesCustodialService: 'Ya (untuk layanan kustodian)',
  nativeDexAddress: 'Akses Native',
  decentralizedAppBrowser: 'Browser Aplikasi Terdesentralisasi',
  biometricLogin: 'Login Biometrik',
  reputationSystem: 'Sistem Reputasi',
  yesInternalWallet: 'Ya (penilaian aplikasi internal)',
  additionalSecurityTools: 'Alat Keamanan Tambahan',
  emergencyStopAnti: 'Henti Darurat, Anti-Peretasan',
  languagesSupport: 'Bahasa yang Didukung',
  multiLanguageSupport: 'Dukungan multi-bahasa',
  english: 'Inggris',
  customerSupport: 'Dukungan Pelanggan',
  yesBuildIt: 'Ya (opsi dukungan bawaan)',
  yesHelpCenter: 'Ya (pusat bantuan)',
  yes24Support: 'Ya (dukungan 24/7)',
  yesInApp: 'Ya (dukungan dalam aplikasi)',
  frequentlyAskedQuestions: 'PERTANYAAN YANG SERING DIAJUKAN',
  howFindFrequently:
    'Di sini Anda dapat menemukan semua pertanyaan yang sering diajukan tentang produk kami',
  faqTitle1: 'Bagaimana cara membuat akun di Aplikasi DOLLUM?',
  faqTitle2: 'Biaya apa yang dikenakan Aplikasi DOLLUM?',
  faqTitle3: 'Apakah aplikasi mendukung integrasi?',
  faqTitle4: 'Bagaimana cara menggunakan fitur Henti Darurat?',
  faqTitle5:
    'Apakah Aplikasi DOLLUM dapat digunakan untuk mengelola item digital?',
  faqTitle6: 'Bagaimana cara memulihkan akses jika perangkat saya hilang?',
  faqText1:
    'Untuk membuat akun, cukup unduh aplikasinya, selesaikan pendaftaran, pilih jenis (kustodian/non-kustodian), dan simpan frasa akses Anda dengan aman.',
  faqText2:
    'Aplikasi DOLLUM secara otomatis mengoptimalkan performa dengan memilih tarif terendah yang tersedia, meminimalkan biaya pengguna saat operasi.',
  faqText3:
    'Ya, Aplikasi DOLLUM sepenuhnya mendukung integrasi, memungkinkan pengguna untuk berpartisipasi dalam integrasi dengan layanan eksternal melalui modul terintegrasi.',
  faqText4:
    'Fitur Henti Darurat langsung mengunci aplikasi jika keamanan terancam. Dapat diaktifkan melalui pengaturan aplikasi.',
  faqText5:
    'Ya, Aplikasi DOLLUM mendukung penyimpanan, tampilan, dan pengelolaan item digital, memungkinkan pengguna untuk dengan aman mengatur koleksi digital mereka langsung di dalam aplikasi.',
  faqText6:
    'Anda dapat memulihkan akses menggunakan frasa yang diberikan saat membuat akun. Pastikan menyimpannya di tempat yang aman.',
  footerReservedText:
    'Situs ini dioperasikan oleh SecureLabs LTd yang didirikan sesuai hukum Seychelles. Semua hak dilindungi.',
  termsOfUse: 'Syarat penggunaan',
  privacyPolicy: 'Kebijakan Privasi',
  cookiePreferences: 'Preferensi Cookie',
  agreeToTransaction:
    'Saya setuju dengan tindakan ini, serta klausul yang dijelaskan dalam ',
  and: 'dan',
  termsAndConditions: 'Syarat dan Ketentuan',
  alsoYouCan: 'Anda juga dapat memverifikasi konfirmasi alokasi Anda di ',
  usingTheTransaction:
    'menggunakan ID operasi. Anda selalu dapat melihat jadwal rinci rilis unit DOL Anda di situs ini dengan memberikan alamat penerima.',
  followUsOn: 'Ikuti kami di media sosial',
  lockedFor: 'Terkunci selama',
  selectNetwork: 'Pilih jaringan',
  dolTokenWill: 'DOL akan diluncurkan di Jaringan Binance Smart Chain',
  copyTxHash: 'Salin ID operasi',
  theOperationExpired: 'Operasi telah kedaluwarsa',
  waitingTimeHas: 'Waktu tunggu habis, coba lagi',
  ifTheProblem: 'Jika masalah berulang, mohon ',
  sendUsEmail: 'kirim email kepada kami',
  contactSupport: 'hubungi dukungan',
  tryAgain: 'Coba lagi',
  theOperationFailed: 'Operasi gagal',
  error: 'Kesalahan',
  tokenUnlockingSchedule: 'Jadwal rilis:',
  promoCodeUsed: 'Kode promo berhasil digunakan',
  congratulations: 'Selamat',
  youCanActivate: 'Anda dapat mengaktifkan kode promo untuk ',
  activateYourPromocode: 'Aktifkan kode promo Anda',
  getting: 'Mendapatkan',
  totalRaisedInUsd: 'Total terkumpul',
  nextStage: 'Tahap berikutnya',
  pay: 'Bayar',
  info: 'Info',
  dollumApp: 'Aplikasi Dollum',
  trustApp: 'Aplikasi Trust',
  metamask: 'Metamask',
  coinbaseApp: 'Aplikasi Coinbase',
  exodusApp: 'Aplikasi Exodus',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '1,5 miliar pada 2023',
  bonusRowsGrowth1: '1,5 miliar pada 2023',
  bonusRowsState2: '320+ juta pengguna kripto',
  multiformatSupport: 'Dukungan multiformat',
  iosAndroidDesktopLightVersion: 'iOS, Android, Desktop (Versi Ringan)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Browser',
  iosAndroidDesktop: 'iOS, Android, Desktop',
  biometricPin2Fa:
    'Biometrik, PIN, 2FA, pin SSL, enkripsi AES-256, `Emergency Stop`, `Anti-Hijack`',
  ethereum: 'Ethereum',

  poweredBy: 'Didukung oleh',
  live: 'Langsung',
  auditAndKycVerified: 'Audit & KYC Terverifikasi',
  teamKycVerification: 'Verifikasi KYC Tim',
  smartContractAudit: 'Audit Smart Contract',
  securityComesFirst: 'Keamanan adalah yang utama.',
  ourSmartContractHasBeenFullyAudited:
    'Smart contract kami telah diaudit sepenuhnya',
  bySolidProof: 'oleh SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'salah satu perusahaan audit blockchain terkemuka.',
  additionally: 'Selain itu,',
  dollumTeamCompletedKYC: 'tim Dollum berhasil menyelesaikan verifikasi KYC',
  ensuringTransparencyAndAccountability:
    ', memastikan transparansi dan akuntabilitas untuk komunitas kami.',
  servicesAndCertificates: 'Layanan & Sertifikat',
  kyc: 'KYC',
  securityScore: 'Skor Keamanan',
  poor: 'Buruk',
  excellent: 'Sangat Baik',
  writesMediaAboutUs: 'Media tentang kami',

  stageTwoAlmostSold: 'Tahap 2 hampir habis terjual — Harga berikutnya: $0.20',
  buyBeforeThePriceIncreases: 'Beli sekarang seharga $0.15 sebelum harga naik!',
};
